"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Toolbar = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _ButtonGroup = _interopRequireDefault(require("@material-ui/core/ButtonGroup"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _useColors = _interopRequireWildcard(require("../../hooks/use-colors"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _Brightness = _interopRequireDefault(require("@material-ui/icons/Brightness4"));

var _PanTool = _interopRequireDefault(require("@material-ui/icons/PanTool"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Create = _interopRequireDefault(require("@material-ui/icons/Create"));

var _classnames = _interopRequireDefault(require("classnames"));

var _useToolMode3 = _interopRequireDefault(require("../../hooks/use-tool-mode"));

var _useEventCallback = _interopRequireDefault(require("use-event-callback"));

var _recoil = require("recoil");

var _creatable = _interopRequireDefault(require("react-select/creatable"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _LocationOn = _interopRequireDefault(require("@material-ui/icons/LocationOn"));

var _Timelapse = _interopRequireDefault(require("@material-ui/icons/Timelapse"));

var _ZoomIn = _interopRequireDefault(require("@material-ui/icons/ZoomIn"));

var _PlayCircleOutline = _interopRequireDefault(require("@material-ui/icons/PlayCircleOutline"));

var _PauseCircleOutline = _interopRequireDefault(require("@material-ui/icons/PauseCircleOutline"));

var _color = _interopRequireDefault(require("color"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Container = (0, _styles.styled)("div")(function (_ref) {
  var themeColors = _ref.themeColors;
  return {
    display: "flex",
    paddingBottom: 16,
    "&&& .MuiButtonBase-root": {
      borderColor: themeColors.fg
    },
    "&&& .MuiButton-label": {
      color: themeColors.fg,
      textTransform: "none"
    },
    "&&& .active.MuiButtonBase-root": {
      backgroundColor: themeColors.fg
    },
    "&&& .active .MuiButton-label": {
      color: themeColors.bg
    },
    "&&& .MuiSvgIcon-root": {
      width: 16,
      height: 16
    }
  };
});

var getSelectFieldStyles = function getSelectFieldStyles(themeColors) {
  return {
    control: function control(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        border: "1px solid ".concat(themeColors.dark ? "rgba(255,255,255,0.5)" : "rgba(0,0,0,0.5)"),
        boxShadow: "none",
        backgroundColor: themeColors.bg,
        borderColor: themeColors.base1,
        userSelect: "none",
        "&:hover": {
          backgroundColor: (0, _color.default)(themeColors.bg).darken(0.2).string()
        }
      });
    },
    input: function input(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        color: themeColors.fg
      });
    },
    option: function option(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        backgroundColor: themeColors.base02,
        color: themeColors.fg,
        "&:hover": {
          backgroundColor: (0, _color.default)(themeColors.bg).darken(0.2).string()
        },
        "&:focus": {
          backgroundColor: (0, _color.default)(themeColors.bg).darken(0.2).string()
        }
      });
    },
    singleValue: function singleValue(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        color: themeColors.fg
      });
    },
    menu: function menu(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        backgroundColor: themeColors.base02
      });
    }
  };
};

var iconStyle = {
  width: 20,
  height: 20
};

var Toolbar = function Toolbar(_ref2) {
  var _durationGroups$selec, _durationGroups$selec2;

  var _ref2$timestamps = _ref2.timestamps,
      timestamps = _ref2$timestamps === void 0 ? [] : _ref2$timestamps,
      selectedTimestampIndex = _ref2.selectedTimestampIndex,
      _ref2$durationGroups = _ref2.durationGroups,
      durationGroups = _ref2$durationGroups === void 0 ? [] : _ref2$durationGroups,
      _ref2$durationLabels = _ref2.durationLabels,
      durationLabels = _ref2$durationLabels === void 0 ? [] : _ref2$durationLabels,
      _ref2$timestampLabels = _ref2.timestampLabels,
      timestampLabels = _ref2$timestampLabels === void 0 ? [] : _ref2$timestampLabels,
      selectedDurationGroupIndex = _ref2.selectedDurationGroupIndex,
      selectedDurationIndex = _ref2.selectedDurationIndex,
      onChangeSelectedItemLabel = _ref2.onChangeSelectedItemLabel,
      _ref2$allowCustomLabe = _ref2.allowCustomLabels,
      allowCustomLabels = _ref2$allowCustomLabe === void 0 ? false : _ref2$allowCustomLabe,
      onStartPlayback = _ref2.onStartPlayback,
      onStopPlayback = _ref2.onStopPlayback,
      _ref2$isPlayingMedia = _ref2.isPlayingMedia,
      isPlayingMedia = _ref2$isPlayingMedia === void 0 ? false : _ref2$isPlayingMedia;
  var themeColors = (0, _useColors.default)();

  var _useToolMode = (0, _useToolMode3.default)(),
      _useToolMode2 = _slicedToArray(_useToolMode, 2),
      mode = _useToolMode2[0],
      setToolMode = _useToolMode2[1];

  var setTheme = (0, _recoil.useSetRecoilState)(_useColors.themeAtom);

  var _useMemo = (0, _react.useMemo)(function () {
    var labelSet = new Set(durationLabels);
    var labelColorMap = {};

    var _iterator = _createForOfIteratorHelper(durationGroups),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var dg = _step.value;

        var _iterator2 = _createForOfIteratorHelper(dg.durations),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var duration = _step2.value;
            if (!duration.label) continue;
            labelSet.add(duration.label);
            labelColorMap[duration.label] = duration.color || dg.color;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        if (!dg.label) continue;
        labelSet.add(dg.label);
        labelColorMap[dg.label] = dg.color;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return [labelSet, labelColorMap];
  }, [timestamps, durationGroups, durationLabels]),
      _useMemo2 = _slicedToArray(_useMemo, 2),
      durationLabelSet = _useMemo2[0],
      durationLabelColorMap = _useMemo2[1];

  var _useMemo3 = (0, _react.useMemo)(function () {
    var labelSet = new Set(timestampLabels);
    var labelColorMap = {};

    var _iterator3 = _createForOfIteratorHelper(timestamps),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var timestamp = _step3.value;
        if (!timestamp.label) continue;
        labelSet.add(timestamp.label);
        labelColorMap[timestamp.label] = timestamp.color;
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    return [labelSet, labelColorMap];
  }, [timestamps, durationGroups, timestampLabels]),
      _useMemo4 = _slicedToArray(_useMemo3, 2),
      timestampLabelSet = _useMemo4[0],
      timestampLabelColorMap = _useMemo4[1];

  var onSelectCreateTool = (0, _useEventCallback.default)(function () {
    return setToolMode("create");
  });
  var onSelectPanTool = (0, _useEventCallback.default)(function () {
    return setToolMode("pan");
  });
  var onSelectZoomTool = (0, _useEventCallback.default)(function () {
    return setToolMode("zoom");
  });
  var onSelectCloseTool = (0, _useEventCallback.default)(function () {
    return setToolMode("delete");
  });
  var toggleTheme = (0, _useEventCallback.default)(function () {
    return setTheme(themeColors.dark ? "light" : "dark");
  });
  var selectFieldStyles = (0, _react.useMemo)(function () {
    return getSelectFieldStyles(themeColors, selectedTimestampIndex);
  }, [themeColors, selectedTimestampIndex]);
  var formatCreateLabel = (0, _useEventCallback.default)(function (s) {
    return "Add \"".concat(s, "\"");
  });
  var onChangeSelectedLabel = (0, _useEventCallback.default)(function (newValue) {
    var _ref3 = newValue || {},
        label = _ref3.label;

    onChangeSelectedItemLabel({
      label: label,
      color: durationLabelColorMap[label] || timestampLabelColorMap[label]
    });
  });
  var timestampCreatableSelectOptions = (0, _react.useMemo)(function () {
    return Array.from(timestampLabelSet).map(function (label) {
      return {
        label: label,
        value: label
      };
    });
  }, [timestampLabelSet]);
  var durationCreatableSelectOptions = (0, _react.useMemo)(function () {
    return Array.from(durationLabelSet).map(function (label) {
      return {
        label: label,
        value: label
      };
    });
  }, [durationLabelSet]);
  var selectedTimestamp = typeof selectedTimestampIndex === "number" ? timestamps[selectedTimestampIndex] : null;
  var selectedDuration = typeof selectedDurationGroupIndex === "number" && typeof selectedDurationIndex === "number" ? durationGroups === null || durationGroups === void 0 ? void 0 : (_durationGroups$selec = durationGroups[selectedDurationGroupIndex]) === null || _durationGroups$selec === void 0 ? void 0 : (_durationGroups$selec2 = _durationGroups$selec.durations) === null || _durationGroups$selec2 === void 0 ? void 0 : _durationGroups$selec2[selectedDurationIndex] : null;
  var selectedItemValue = (0, _react.useMemo)(function () {
    var label = (selectedTimestamp === null || selectedTimestamp === void 0 ? void 0 : selectedTimestamp.label) || (selectedDuration === null || selectedDuration === void 0 ? void 0 : selectedDuration.label);
    return {
      label: label,
      value: label
    };
  }, [selectedTimestamp, selectedDuration]);
  var SelectComponent = allowCustomLabels ? _creatable.default : _reactSelect.default;
  return /*#__PURE__*/_react.default.createElement(Container, {
    themeColors: themeColors
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    color: themeColors.fg,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingRight: 1
  }, selectedTimestamp ? /*#__PURE__*/_react.default.createElement(_LocationOn.default, {
    style: _objectSpread(_objectSpread({}, iconStyle), {}, {
      color: selectedTimestamp.color || themeColors.fg
    })
  }) : selectedDuration ? /*#__PURE__*/_react.default.createElement(_Timelapse.default, {
    style: _objectSpread(_objectSpread({}, iconStyle), {}, {
      color: selectedDuration.color || themeColors.fg
    })
  }) : null), /*#__PURE__*/_react.default.createElement(_Box.default, {
    display: "block",
    height: 40,
    flexGrow: 1,
    paddingRight: 2
  }, (selectedTimestamp || selectedDuration) && /*#__PURE__*/_react.default.createElement(SelectComponent, {
    isClearable: true,
    value: selectedItemValue,
    formatCreateLabel: formatCreateLabel,
    styles: selectFieldStyles,
    onChange: onChangeSelectedLabel,
    options: selectedTimestamp ? timestampCreatableSelectOptions : durationCreatableSelectOptions
  })), /*#__PURE__*/_react.default.createElement(_ButtonGroup.default, {
    size: "small"
  }, onStartPlayback && !isPlayingMedia && /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: onStartPlayback,
    className: (0, _classnames.default)({
      active: isPlayingMedia
    })
  }, /*#__PURE__*/_react.default.createElement(_PlayCircleOutline.default, null)), onStopPlayback && isPlayingMedia && /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: onStopPlayback,
    className: (0, _classnames.default)({
      active: isPlayingMedia
    })
  }, /*#__PURE__*/_react.default.createElement(_PauseCircleOutline.default, null)), /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: onSelectCreateTool,
    className: (0, _classnames.default)({
      active: mode === "create"
    })
  }, /*#__PURE__*/_react.default.createElement(_Create.default, null)), /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: onSelectPanTool,
    className: (0, _classnames.default)({
      active: mode === "pan"
    })
  }, /*#__PURE__*/_react.default.createElement(_PanTool.default, null)), /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: onSelectZoomTool,
    className: (0, _classnames.default)({
      active: mode === "zoom"
    })
  }, /*#__PURE__*/_react.default.createElement(_ZoomIn.default, null)), /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: onSelectCloseTool,
    className: (0, _classnames.default)({
      active: mode === "delete"
    })
  }, /*#__PURE__*/_react.default.createElement(_Close.default, null))), /*#__PURE__*/_react.default.createElement(_Box.default, {
    display: "flex",
    paddingLeft: 1
  }, /*#__PURE__*/_react.default.createElement(_ButtonGroup.default, {
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: toggleTheme
  }, /*#__PURE__*/_react.default.createElement(_Brightness.default, null)))));
};

exports.Toolbar = Toolbar;
var _default = Toolbar;
exports.default = _default;